<template>
  <div class="container">
    <CommonFrame
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :moduleName="moduleName"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus">
      <div slot="info">
        <span class="mr8" v-for="(item,index) in infosArr" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <lk-card :title="isApproval ? '本期付款单信息' : '付款信息'" class="mb16">
          <lk-form
            label-position="right"
            :labelWidth="134">
            <lk-row>
              <lk-col span="23">
                <lk-form-item>
                  <lk-table :columns="payableColumns" :data="paidList" border>
                    <div slot="footer" class="payment-total">
                      <span v-if="isApproval">总计: {{processedAmount}}</span>
                      <span v-else>已付款总计: {{finishPaymentRecordAmount}}</span>
                    </div>
                  </lk-table>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="付款单明细" class="mb16">
          <lk-form
            :label-width="134"
            label-position="right"
          >
            <lk-row>
              <lk-col span="23">
                <lk-form-item>
                  <lk-table :columns="columns" :data="tableData" border></lk-table>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import CommonFrame from '../commonFrame.vue';
import utils from '../../../libs/utils';

export default {
  name: 'destroyFlow',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
  },
  data() {
    return {
      workNo: '',
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批管理',
        },
        {
          name: 'approvalEdit',
          title: '付款审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
      processedAmount: 0,
      finishPaymentRecordAmount: 0,
      payableColumns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 110,
        },
        {
          title: '金额',
          key: 'amount',
          minWidth: 116,
        },
        {
          title: '类型',
          key: 'payWay',
          minWidth: 116,
          render: (h, { row }) => h('span', this.payWayMap.get(row.payWay)),
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 116,
        },
      ],
      paidList: [],
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 110,
        },
        {
          title: '应付单号',
          key: 'payableCode',
          minWidth: 110,
        },
        {
          title: '来源单据',
          key: 'referCode',
          minWidth: 110,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
        },
        {
          title: '通用名',
          key: 'approvedDrugName',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'specification',
          minWidth: 110,
        },
        {
          title: '含税进货价',
          key: 'realPriceWithTax',
          minWidth: 110,
        },
        {
          title: '数量',
          key: 'num',
          minWidth: 110,
        },
        {
          title: '确认税率',
          key: 'realInputTaxRate',
          minWidth: 110,
        },
        {
          title: '含税金额',
          key: 'totalPriceBeforeTax',
          minWidth: 110,
        },
        {
          title: '不含税金额',
          key: 'totalPriceAfterTax',
          minWidth: 110,
        },
        {
          title: '税额',
          key: 'totalTax',
          minWidth: 110,
        },
      ],
      tableData: [],
      destroyTime: '',
    };
  },
  computed: {
    payWayMap() {
      return this.$store.state.publicParams.payWayMap;
    },
    isApproval() {
      // 待审批状态
      return this.$route.params.approvalTabStatus === '2';
    },
  },
  methods: {
    getInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        const data = res.data.data;
        this.processedAmount = data.processedAmount || 0;
        this.finishPaymentRecordAmount = data.finishPaymentRecordAmount || 0;

        // 付款记录
        data.financePaymentRecordList.forEach((item) => {
          item.createTime = utils.formatDate(item.createTime);
        });

        // 未审批展示本期付款信息
        if (this.isApproval) {
          this.paidList = data.processedRecordList;
        } else {
          this.paidList = data.financePaymentRecordList;
        }

        // 付款单明细
        data.payableVoInfoList.forEach((item) => {
          item.realInputTaxRate = `${item.realInputTaxRate}%`;
        });
        this.tableData = data.payableVoInfoList;
        this.setArrInfo(data.financePayment);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    setArrInfo(data) {
      this.infosArr.push({
        name: '付款单号',
        value: data.code,
      }, {
        name: '单据总金额',
        value: data.amount,
      }, {
        name: '门店名称',
        value: data.storeName,
      }, {
        name: '供应商名称',
        value: data.supplierName,
      }, {
        name: '创建人',
        value: data.createUserName,
      }, {
        name: '创建时间',
        value: utils.formatTime(data.createTime),
      });

      if (this.isApproval) {
        this.infosArr.splice(2, 0, {
          name: '本期付款金额',
          value: this.processedAmount,
        });
      }
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;
    this.getInfo(this.approvalParams.businessUrl);

    if (!this.isApproval) {
      this.payableColumns.splice(3, 0, ...[{
        title: '创建时间',
        key: 'createTime',
        minWidth: 110,
      }, {
        title: '审批状态',
        key: 'statusName',
        minWidth: 110,
      }]);
    }
  },
};
</script>
<style lang="less">
  .payment-total {
    padding-left: 16px;
  }
</style>
